import React, { Fragment, useReducer, useEffect } from 'react';
import LearnosityProvider from 'legacy-src/utility/LearnosityProvider';
import { isImpersonating } from 'legacy-src/components/impersonating/utils';
import { initialState, reducer, ACTIONS } from '../state/reducer';
import { isEmpty } from 'lodash';

const WithLearnosityData = (WrappedComponent) => (props) => {
  const {
    learnosityRequestResults,
    learnosityRequestResultsByItem,
    learnosityRequestResultsByRubric,
    learnosityRequestResponseAnalysis,
    learnosityRequestScoringRubricResponseAnalysis,
    learnosityRequestStudentScoringResults,
    learnosityRequestTeacherScoringResults,
    trackResultsVisit,
    featureFlags,
    assignmentResultsLoading,
  } = props;
  const [state, dispatch] = useReducer(
    reducer,
    initialState({
      learnosityRequestResults,
      learnosityRequestResultsByItem,
      learnosityRequestResultsByRubric,
      learnosityRequestResponseAnalysis,
      learnosityRequestScoringRubricResponseAnalysis,
      learnosityRequestStudentScoringResults,
      learnosityRequestTeacherScoringResults,
      featureFlags,
    }),
  );
  const {
    isReadyResultsByItem,
    isReadyResults,
    isReadyResultsByRubric,
    isReadyResponseAnalysis,
    isReadyScoringRubricResponseAnalysis,
    isReadyStudentScoringResults,
    isReadyTeacherScoringResults,
    studentScoringResults,
    teacherScoringResults,
    resultsByRubric,
    resultsByItem,
    results,
  } = state;

  const noResults =
    isEmpty(results) &&
    isEmpty(studentScoringResults) &&
    isEmpty(teacherScoringResults) &&
    isEmpty(resultsByRubric) &&
    isEmpty(resultsByItem);

  let isReady =
    !assignmentResultsLoading &&
    (!isEmpty(studentScoringResults) ||
      !isEmpty(teacherScoringResults) ||
      !isEmpty(resultsByRubric) ||
      !isEmpty(resultsByItem)) &&
    isReadyResults &&
    isReadyResultsByItem &&
    isReadyResultsByRubric &&
    isReadyResponseAnalysis &&
    isReadyScoringRubricResponseAnalysis &&
    isReadyStudentScoringResults &&
    isReadyTeacherScoringResults;

  const assignmentApiResults = [
    learnosityRequestResponseAnalysis,
    learnosityRequestResults,
    learnosityRequestResultsByItem,
    learnosityRequestResultsByRubric,
    learnosityRequestScoringRubricResponseAnalysis,
    learnosityRequestStudentScoringResults,
    learnosityRequestTeacherScoringResults,
  ];
  if (
    !assignmentResultsLoading &&
    assignmentApiResults.every((el) => el === null)
  ) {
    isReady = true;
  }

  useEffect(() => {
    !isImpersonating() && trackResultsVisit();
  }, []);

  return (
    <Fragment>
      {!!learnosityRequestResults && (
        <LearnosityProvider
          containerElement="learnosity_report_results"
          apiType="reports"
          initOptions={JSON.parse(learnosityRequestResults)}
          dataListener={(payload) =>
            dispatch({ type: ACTIONS.onLearnosityDataResultsReady, payload })
          }
        />
      )}

      {!!learnosityRequestResultsByItem && (
        <LearnosityProvider
          containerElement="learnosity_report_results_by_item"
          apiType="reports"
          initOptions={JSON.parse(learnosityRequestResultsByItem)}
          dataListener={(payload) =>
            dispatch({
              type: ACTIONS.onLearnosityDataResultsByItemReady,
              payload,
            })
          }
        />
      )}

      {!!learnosityRequestResultsByRubric && (
        <LearnosityProvider
          containerElement="learnosity_report_results_by_rubric"
          apiType="reports"
          initOptions={JSON.parse(learnosityRequestResultsByRubric)}
          dataListener={(payload) =>
            dispatch({
              type: ACTIONS.onLearnosityDataResultsByRubricReady,
              payload,
            })
          }
        />
      )}

      {!!learnosityRequestStudentScoringResults && (
        <LearnosityProvider
          containerElement="learnosity_report_student_scoring_results"
          apiType="reports"
          initOptions={JSON.parse(learnosityRequestStudentScoringResults)}
          dataListener={(payload) =>
            dispatch({
              type: ACTIONS.onLearnosityDataStudentScoringResultsReady,
              payload,
            })
          }
        />
      )}

      {!!learnosityRequestTeacherScoringResults && (
        <LearnosityProvider
          containerElement="learnosity_report_teacher_scoring_results"
          apiType="reports"
          initOptions={JSON.parse(learnosityRequestTeacherScoringResults)}
          dataListener={(payload) =>
            dispatch({
              type: ACTIONS.onLearnosityDataTeacherScoringResultsReady,
              payload,
            })
          }
        />
      )}
      <WrappedComponent
        {...props}
        {...state}
        isReady={isReady}
        noResults={noResults}
      />
    </Fragment>
  );
};

export default WithLearnosityData;
